const containerModel = document.getElementById('container_1');
const vertex_shader = 
	`uniform float delta;
	void main()
	{
		vec3 p = position.xyz;
		float new_x = p.x*cos(delta) - p.y*sin(delta);
		float new_y = p.y*cos(delta) + p.x*sin(delta);

		gl_Position = projectionMatrix * modelViewMatrix * vec4(new_x, new_y, p.z, 1.0);
	}`

	function initBadTv(){
	/**
	 * @author Felix Turner / www.airtight.cc / @felixturner
	 *
	 * Bad TV Shader
	 * Simulates a bad TV via horizontal distortion and vertical roll
	 * Uses Ashima WebGl Noise: https://github.com/ashima/webgl-noise
	 *
	 * Uniforms:
	 * time: steadily increasing float passed in
	 * distortion: amount of thick distortion
	 * distortion2: amount of fine grain distortion
	 * speed: distortion vertical travel speed
	 * rollSpeed: vertical roll speed
	 * 
	 * The MIT License
	 * 
	 * Copyright (c) Felix Turner
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */

	THREE.BadTVShader = {
		uniforms: {
			"tDiffuse": 	{ type: "t", value: null },
			"time": 		{ type: "f", value: 0.0 },
			"distortion":   { type: "f", value: 3.0 },
			"distortion2":  { type: "f", value: 5.0 },
			"speed":     	{ type: "f", value: 0.2 },
			"rollSpeed":    { type: "f", value: 0.1 },
		},

		vertexShader: [
			
			"varying vec2 vUv;",
			"void main() {",
			"vUv = uv;",
			"gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
			"}"

		].join("\n"),

		fragmentShader: [

			"uniform sampler2D tDiffuse;",
			"uniform float time;",
			"uniform float distortion;",
			"uniform float distortion2;",
			"uniform float speed;",
			"uniform float rollSpeed;",
			"varying vec2 vUv;",
			
			// Start Ashima 2D Simplex Noise

			"vec3 mod289(vec3 x) {",
			"  return x - floor(x * (1.0 / 289.0)) * 289.0;",
			"}",

			"vec2 mod289(vec2 x) {",
			"  return x - floor(x * (1.0 / 289.0)) * 289.0;",
			"}",

			"vec3 permute(vec3 x) {",
			"  return mod289(((x*34.0)+1.0)*x);",
			"}",

			"float snoise(vec2 v)",
			"  {",
			"  const vec4 C = vec4(0.211324865405187,  // (3.0-sqrt(3.0))/6.0",
			"                      0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)",
			"                     -0.577350269189626,  // -1.0 + 2.0 * C.x",
			"                      0.024390243902439); // 1.0 / 41.0",
			"  vec2 i  = floor(v + dot(v, C.yy) );",
			"  vec2 x0 = v -   i + dot(i, C.xx);",

			"  vec2 i1;",
			"  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);",
			"  vec4 x12 = x0.xyxy + C.xxzz;",
			" x12.xy -= i1;",

			"  i = mod289(i); // Avoid truncation effects in permutation",
			"  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))",
			"		+ i.x + vec3(0.0, i1.x, 1.0 ));",

			"  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);",
			"  m = m*m ;",
			"  m = m*m ;",

			"  vec3 x = 2.0 * fract(p * C.www) - 1.0;",
			"  vec3 h = abs(x) - 0.5;",
			"  vec3 ox = floor(x + 0.5);",
			"  vec3 a0 = x - ox;",

			"  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );",

			"  vec3 g;",
			"  g.x  = a0.x  * x0.x  + h.x  * x0.y;",
			"  g.yz = a0.yz * x12.xz + h.yz * x12.yw;",
			"  return 130.0 * dot(m, g);",
			"}",

			// End Ashima 2D Simplex Noise

			"void main() {",

				"vec2 p = vUv;",
				"float ty = time*speed;",
				"float yt = p.y - ty;",
				//smooth distortion
				"float offset = snoise(vec2(yt*3.0,0.0))*0.2;",
				// boost distortion
				"offset = offset*distortion * offset*distortion * offset;",
				//add fine grain distortion
				"offset += snoise(vec2(yt*50.0,0.0))*distortion2*0.001;",
				//combine distortion on X with roll on Y
				"gl_FragColor = texture2D(tDiffuse,  vec2(fract(p.x + offset),fract(p.y-time*rollSpeed) ));",

			"}"

		].join("\n")
	}
}

initBadTv()

let renderer, scene, camera, composer, controls, ball, rgbSplit, tvSplit, badTVParams, rgbParams, root;
if (containerModel) {
  init();
}


function init() {
	
  renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true
  });
  renderer.setPixelRatio((window.devicePixelRatio) ? window.devicePixelRatio : 1);
  renderer.setSize(window.innerWidth - 10, window.innerHeight - 10);
  renderer.autoClear = false;
  renderer.toneMapping = THREE.ReinhardToneMapping;
  renderer.setClearColor(0x000000, 0.0);
  document.getElementById('container_1').appendChild(renderer.domElement);

  scene = new THREE.Scene();

  camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1000);
  camera.position.z = 50;
  scene.add(camera);

  ball = new THREE.Object3D();

  scene.add(ball);


  var mat_ball = new THREE.MeshPhongMaterial({
    color: 0x333333,
	specular: 0x777777,
	transparent: true,
	opacity: 0,
  });
  let op = {
	  o: 0
  }
  const gltfLoader = new THREE.GLTFLoader();
			const url = 'img/markoff-2.glb';
			gltfLoader.load(url, (gltf) => {
				root = gltf.scene;
				scene.add(root);
                root.position.y = -20.1
                root.position.z = 10
                root.scale.set(3.5,3.5,3.5)
              
				gltf.scene.traverse(function(child) {
					if (child instanceof THREE.Mesh) {
							child.material = mat_ball

							// анимация появления (1500 - время выполнения анимации)

							const a = new TWEEN.Tween(op)
							.to({o: 1}, 1500)
							.easing(TWEEN.Easing.Quadratic.Out)
							.onUpdate(() => {
								child.material.opacity = op.o
							})
							.start()
					}
                });
			
			   animate()
			});
			

		let lightClor = 0x333333
		
		let hlight = new THREE.AmbientLight(Number(lightClor));
		scene.add(hlight);

		let directionalLight = new THREE.DirectionalLight( Number(0x777777), 1);
		directionalLight.position.set(0, 1, 0);
		directionalLight.castShadow = true;
		scene.add(directionalLight);

		let light = new THREE.PointLight( Number(lightClor), 1);
		light.position.set(0, 300, 500);
		scene.add(light);

		let light2 = new THREE.PointLight(Number(lightClor), 1);
		light2.position.set(500, 100, 0);
		scene.add(light2);

		let  light3 = new THREE.PointLight(Number(lightClor), 1);
		light3.position.set(0, 100, -500);
		scene.add(light3);

		let light4 = new THREE.PointLight(Number(0x2a1e5b), 1);
		light4.position.set(-500, 300, 500);
		scene.add(light4);


  var renderModel = new THREE.RenderPass(scene, camera);
  composer = new THREE.EffectComposer(renderer);
  composer.addPass(renderModel);

    // composer = new THREE.EffectComposer( renderer);
    // renderPass = new THREE.RenderPass( scene, camera );
    // badTVPass = new THREE.ShaderPass( THREE.BadTVShader );
    // composer.addPass( renderPass );
    // composer.addPass( badTVPass );
    // badTVPass.renderToScreen = true;

  rgbSplit = new THREE.ShaderPass(THREE.RGBShiftShader);
  tvSplit = new THREE.ShaderPass(THREE.BadTVShader);

  badTVParams = {
    distortion: 1.0,
    distortion2: 1.0,
  }
  rgbParams = {
    amount: 0.15,
    angle: 0.0,
  }

  anineOut();

  composer.addPass(rgbSplit);
  composer.addPass(tvSplit);

  tvSplit.renderToScreen = true;
  rgbSplit.renderToScreen = true;

//   ниже задается интервал для появления глитча

  setInterval(randomizeParams, 3000);

  window.addEventListener('resize', onWindowResize, false);

};

function anineOut() {
  rgbSplit.uniforms["amount"].value = 0;
  tvSplit.uniforms["distortion"].value = 0;
  tvSplit.uniforms["distortion2"].value = 0;
};

function randomizeParams() {
	// badTVParams.distortion - изгибает модель, поэтому 0
	// badTVParams.distortion2 - менять только цифру 4 (если нужно ослабить/усилить искажение модели (ребристость))
    badTVParams.distortion =  0;
    badTVParams.distortion2 = Math.random() * 4 + 0.1;

	//  rgbParams.angle - угол = кол-во частил rbg спектра
	//  rgbParams.amount - кол-во распадания на спектр
    rgbParams.angle = Math.random() * 2;
    rgbParams.amount = Math.random() * 0.03 ;

    rgbSplit.uniforms["amount"].value = rgbParams.amount * Math.random();
	rgbSplit.uniforms["angle"].value = rgbParams.angle * Math.PI;
	tvSplit.uniforms["distortion"].value = badTVParams.distortion * Math.random();
	tvSplit.uniforms["distortion2"].value = badTVParams.distortion2 * Math.random();

	// ниже задается время, через которое исчезает глитч
	setTimeout(anineOut, 500);
}

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
  composer.setSize(window.innerWidth, window.innerHeight);
}

function animate() {
  requestAnimationFrame(animate);
  root.rotation.y += 0.02;
  composer.render();
  TWEEN.update()
//   tvSplit.uniforms["time"].value += ;
};

	if(window.matchMedia('(min-width: 768px)').matches){
		let a = document.querySelector('#container_1')
		
		a ? setTimeout(() => {
			a.setAttribute('data-depth', 0.5)
			let scene = document.getElementById('parallax');
			let parallaxInstance = new Parallax(scene);
		}, []) : false
	}
